import React from 'react';
import './card.css';
import { directDeepLink, SOURCE_HOME } from '../../util.js';
export default function Card(props) {
	const data = props?.data;
	const buyButtonLabel = props?.buyButtonLabel || 'Buy Now';
	const discountBadgeIcon = props?.discountBadgeIcon || 'https://cdn-cp-assets-public.classplus.co/campaigns-assets/birthday-sale-discount-white268.png';
	function cardClick(){
		let DeepLink = data?.courses[0]?.deeplink;
		DeepLink.paramOne = DeepLink.paramOne + "";
		window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(DeepLink));
		directDeepLink(DeepLink, SOURCE_HOME);
	}
	return (
		<>
			<div className="studentSliderCard">
				<div className="cardContent">
					<h2 className="cardTitle">{data?.title}</h2>
					<hr className="cardDivider"/>
					<div className="cardImage">
						{data?.courses[0]?.imageUrl ? (
							<img className="courseImage" src={data?.courses[0]?.imageUrl} alt="courseImage"/>
						) : (
							<img className="courseImage"
								 src="https://cdn-cp-assets-public.classplus.co/cams/cards-icon/default_course.png"
								 alt="default_course"/>
						)}
					</div>
					<h2 className="cardCourseText">{data?.courses[0]?.name}</h2>
					{data?.courses[0]?.couponEmblem?.text &&
						<div className="textCouponCode">
							<img
								src={discountBadgeIcon}
								alt="discount" width="14" height="15"/>
							{data?.courses[0]?.couponEmblem?.text}
						</div>
					}
					<div className="cardPriceFlex">
						<div className="textFinalPrice">₹{data?.courses[0]?.finalPrice}/-</div>
						<div className="textOldPrice">₹{data?.courses[0]?.price}/-</div>
						<div className="textDiscount">{Math.floor(data?.courses[0]?.discountPercentage) || 0}% OFF</div>
					</div>
					<button className="cardActionBtn" onClick={cardClick}>{buyButtonLabel}</button>
				</div>
			</div>
		</>

	);
}


